import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { DepletionV2Content } from "@/components/admin/depletion-v2/DepletionV2Content";

export default function AdminDepletionStatusPage() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AdminSidebar />
        <main className="flex-1 p-6 overflow-auto">
          <div className="max-w-7xl mx-auto space-y-6">
            {/* Header */}
            <div>
              <h1 className="text-2xl font-bold">นักเรียนใกล้หมดคอร์ส</h1>
              <p className="text-muted-foreground">
                ดูรายชื่อนักเรียนที่หมดคอร์สหรือใกล้หมดคอร์ส จาก estimated_hours_depletion_date และ estimated_8hours_date
              </p>
            </div>

            <DepletionV2Content />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}

